import dayjs from 'dayjs';

type DateRange = {
  startDate: string; // формат: 'DD-MM-YYYY'
  endDate: string; // формат: 'DD-MM-YYYY'
};

type FullDateRange = DateRange & {
  prevStartDate: string;
  prevEndDate: string;
};

export function getPreviousDateRange({
  startDate,
  endDate,
}: DateRange): FullDateRange {
  const format = 'DD-MM-YYYY';

  const start = dayjs(startDate, format);
  const end = dayjs(endDate, format);
  const diffDays = end.diff(start, 'day') + 1;

  const prevEnd = start.subtract(1, 'day');
  const prevStart = prevEnd.subtract(diffDays - 1, 'day');

  return {
    startDate,
    endDate,
    prevStartDate: prevStart.format(format),
    prevEndDate: prevEnd.format(format),
  };
}
